"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPublicKeyAndAddress = void 0;
const ton_1 = require("ton");
const WalletV4Source_1 = require("./WalletV4Source");
function extractPublicKeyAndAddress(config) {
    // Extract public key and address
    let publicKey;
    let restoredAddress;
    if (config.walletType === 'org.ton.wallets.v4') {
        let source = WalletV4Source_1.WalletV4Source.restore(config.walletConfig);
        restoredAddress = (0, ton_1.contractAddress)(source);
        publicKey = source.publicKey;
    }
    else {
        return null;
    }
    // Public key
    return { publicKey, address: restoredAddress };
}
exports.extractPublicKeyAndAddress = extractPublicKeyAndAddress;
